import Flex from '@Resources/styles/flex.scss';
import { CircularProgress } from '@mui/material';
import axios from 'axios';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import NumberInput from '@Components/DomElements/NumberInput';
import ModalFooter from '@Components/ModalComponents/ModalFooter';
import FoldersApi from '@Data/folders/Api';
import GeoserverApi from '@Data/geoserver/Api';
import Styles from './CreateSubset.scss';

const CreateSubsetDialogue = (props) => {
    const {
        projectId,
        onCancel,
        onComplete,
        setCancelDisabled,
        selectedFolder,
        setFooter,
    } = props;

    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [subsetAmount, setSubsetAmount] = useState<number>(0);
    const [folderEntities, setFolderEntities] = useState<number>(-1);

    useEffect(() => {
        async function getFolderFeatures() {
            const response = await GeoserverApi.getWfsData(
                [selectedFolder.folder_id],
                projectId
            );
            setFolderEntities(response.data.features.length);
        }

        if (selectedFolder && projectId) {
            getFolderFeatures();
        }
    }, [selectedFolder, projectId]);

    const handleSubmit = () => {
        setIsSubmitting(true);
        setCancelDisabled(true);
        FoldersApi.createSubset(selectedFolder, subsetAmount, () => {
            FoldersApi.getFolders(projectId);
            onComplete();
        });
    };

    const innerHtml =
        folderEntities === -1 ? (
            <div
                className={cx(Flex.flex, Flex.justifyCenter)}
                style={{ marginTop: '8px' }}
            >
                <CircularProgress />
            </div>
        ) : (
            <div className={Styles.inputContainer}>
                <NumberInput
                    label="Subset Amount"
                    min={1}
                    max={folderEntities}
                    value={subsetAmount}
                    onChange={(e) => setSubsetAmount(e.target.value)}
                />
                <span className={Styles.maxLabel}>of {folderEntities}</span>
            </div>
        );

    useEffect(() => {
        setFooter(
            <ModalFooter
                id="create-subset-footer"
                onCancel={onCancel}
                onSubmit={handleSubmit}
                submitText="Create Subset"
                canSubmit={
                    subsetAmount > 0 &&
                    subsetAmount <= folderEntities &&
                    folderEntities > -1
                }
                isSubmitting={isSubmitting}
            />
        );
    }, [subsetAmount, folderEntities, isSubmitting]);

    return <div className={cx(Flex.flex, Flex.column)}>{innerHtml}</div>;
};

CreateSubsetDialogue.propTypes = {
    projectId: PropTypes.number,
    onCancel: PropTypes.func,
    onComplete: PropTypes.func,
    setCancelDisabled: PropTypes.func,
    selectedFolder: PropTypes.any,
    setFooter: PropTypes.func,
};
export default CreateSubsetDialogue;
